/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';

import ActionButton from '../../elements/ActionButton';
import DeleteButton from '../../elements/DeleteButton';
import EditButton from '../../elements/EditButton';
import Search from '../../elements/Search';
import ViewButton from '../../elements/ViewButton';
import Card from '../../elements/common/Card';
import SortButton from '../../elements/common/SortButton';
import TableHead from '../../elements/common/TableHead';
import TableLoader from '../../elements/common/TableLoader';
import Paginator from '../../elements/paginator';
import { PERMISSION } from '../../helpers/Permissions';
import useAutoPaginator from '../../hooks/useAutoPaginator';

import CustomRedirectsApi from 'Api/CRM/Modules/CustomRedirectsApi';
import CustomRedirect from 'Api/Models/CustomRedirect';

function CustomRedirectsList() {
    const { items, updateItems, isLoading, auto } = useAutoPaginator<CustomRedirect>((page, params) =>
        CustomRedirectsApi.getCustomRedirects(page, { params })
    );

    return (
        <Card title="All custom redirects">
            <ActionButton
                url="/custom-redirects/create"
                title="Create a custom redirect"
                permissions={[PERMISSION.CREATE_CUSTOM_REDIRECT]}
            />
            <Search {...auto.search} />
            <TableLoader isLoading={isLoading}>
                <table className="table model-list">
                    <TableHead>
                        <div />
                        <SortButton column="id" {...auto.sort} />
                        <SortButton column="source_url" {...auto.sort} />
                        <SortButton column="target_url" {...auto.sort} />
                        <SortButton column="status_code" {...auto.sort} />
                        <SortButton column="updated_at" {...auto.sort} />
                        <SortButton column="created_at" {...auto.sort} />
                    </TableHead>
                    <CustomRedirectsTableBody customRedirects={items} updateCustomRedirects={updateItems} />
                </table>
                <Paginator {...auto.paginator} />
            </TableLoader>
        </Card>
    );
}

type CustomRedirectsTableBodyProps = {
    customRedirects: CustomRedirect[];
    updateCustomRedirects: (page?: number) => Promise<void>;
};

function CustomRedirectsTableBody({ customRedirects, updateCustomRedirects }: CustomRedirectsTableBodyProps) {
    return (
        <tbody>
            {customRedirects.map((customRedirect) => (
                <tr key={customRedirect.id}>
                    <td>
                        <ViewButton
                            url={`/custom-redirects/${customRedirect.id}`}
                            permissions={[PERMISSION.VIEW_CUSTOM_REDIRECT]}
                        />
                        <EditButton
                            url={`/custom-redirects/${customRedirect.id}/edit`}
                            permissions={[PERMISSION.UPDATE_CUSTOM_REDIRECT]}
                        />
                        <DeleteButton
                            url={`/crea/api/custom-redirects/${customRedirect.id}`}
                            action={updateCustomRedirects}
                            permissions={[PERMISSION.DELETE_CUSTOM_REDIRECT]}
                        />
                    </td>
                    <td>{customRedirect.id}</td>
                    <td>{customRedirect.source_url}</td>
                    <td>{customRedirect.target_url}</td>
                    <td>{customRedirect.status_code}</td>
                    <td>{customRedirect.updated_at}</td>
                    <td>{customRedirect.created_at}</td>
                </tr>
            ))}
        </tbody>
    );
}

export default CustomRedirectsList;
